import styled from 'styled-components'
import { ITaskCalendarStageType } from '../../../../../store/calendar/interfaces'

export const TaskIcon = styled.span<{ $stage: ITaskCalendarStageType }>`
  background-color: ${({ $stage }) => {
    switch ($stage) {
      case 'new':
        return 'green'
      case 'expired':
        return 'red'
      default:
        return 'yellow'
    }
  }};
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
`

export const CardWrapper = styled.div<{ $compact?: boolean }>`
  margin-bottom: ${({ $compact }) => ($compact ? '8px' : '12px')};

  .ant-card {
    border-radius: 8px;
    transition: all 0.3s;
    
    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }

  .ant-card-body {
    padding: ${({ $compact }) => ($compact ? '12px' : '16px')};
  }

  .ant-space {
    display: flex;
    width: 100%;
    margin-bottom: 4px;
    font-size: ${({ $compact }) => ($compact ? '12px' : '14px')};
  }
`

